import { createFileRoute } from '@tanstack/react-router';
import { UserForm } from '@/pages/preferences/tabs/users/form';
import { PROTECTED, SETTINGS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${SETTINGS}`;

export const Route = createFileRoute(
  '/protected/_layout/settings/_layout/users/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditUserModal,
});

function EditUserModal() {
  const { id } = Route.useParams();
  return <UserForm id={id} returnUrl={RETURN_URL} />;
}
